// ============================================================
// StatusBadge — Brand Guide v2
//
// JetBrains Mono 10px · weight 700 · 1.5px letter-spacing ·
// 6px radius · color bg 10% · color text · color border 20%.
//
// Use `tone` for the 6 canonical statuses; pass `color` for a
// per-client tint. `dot={true}` adds a leading StatusDot — only
// use when the underlying state is live.
// ============================================================

import StatusDot from './StatusDot'

const TONE_COLORS = {
  live:       '#00a67d',
  verified:   '#00aad2',
  simulation: '#c4a24e',
  pending:    '#c4a24e',
  new:        '#E8854A',
  critical:   '#e85d3a',
  offline:    'rgba(255,255,255,0.35)',
  info:       '#5B9FD4',
}

export default function StatusBadge({
  tone = 'live',
  color,
  dot = false,
  live = false,
  children,
  style: styleOverride,
}) {
  const accent = color || TONE_COLORS[tone] || TONE_COLORS.live

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '3px 9px',
        borderRadius: 6,
        background: `${accent}1a`,
        border: `1px solid ${accent}33`,
        color: accent,
        fontSize: 10,
        fontWeight: 700,
        letterSpacing: '0.15em',
        textTransform: 'uppercase',
        fontFamily: 'var(--sc-font-mono, var(--font-mono))',
        lineHeight: 1.4,
        whiteSpace: 'nowrap',
        ...styleOverride,
      }}
    >
      {dot && <StatusDot color={accent} size={6} pulse={live} />}
      {children}
    </span>
  )
}
